import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M2 6h12v2H2zm0 4h12v2H2zm0 4h8v2H2zm14.01 3L13 14l-1.5 1.5 4.51 4.5L23 13l-1.5-1.5z"
}), 'PlaylistAddCheckTwoTone');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/PlaylistAddCheckTwoTone.js
// module id = 5527
// module chunks = 2